// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dark mode style */
.dark .ReactTable {
	color: #f7f7f7 !important;
}

.dark * {
	box-shadow: none;
}

.dark .main-panel {
	background: #090a0b !important;
}

.dark h2,
.dark h1,
.dark h3,
.dark h4,
.dark h5,
.dark p,
.dark .card h1,
.dark .card-stats-active .btn,
.dark .card label,
.dark * label,
.dark .css-1uccc91-singleValue {
	color: white !important;
}

.dark .css-1rhbuit-multiValue {
	background-color: gray;
}

.dark .ReactTable .-pagination .-btn {
	background-color: #014b84;
}

.dark .rt-tr -odd:hover,
.dark tr:hover {
	background-color: #090a0b !important;
}

.dark thead > tr:hover {
	background-color: inherit !important;
}

.dark .ReactTable .rt-table .rt-td {
	border-top: 1px solid rgba(143, 143, 143, 0.267);
	border-right: 1px solid rgba(143, 143, 143, 0.267);
	text-align: center;
}

.dark .ReactTable .rt-table {
	border: none;
}

.dark .table thead th {
	background-color: #2c2f36;
}

.dark .btn-surface.active {
	background-color: #383838;
	color: #f7f7f7;
}

.dark .table-bordered td,
.table-bordered th {
	border: 1px solid #000;
}

.dark hr {
	background-color: darkgray;
}

.dark .dropdown-menu {
	background: #1a1b1d;
}

.dark.btn-surface:focus {
	color: inherit;
}

.dark .btn-link:hover {
	background-color: #014b84 !important;
}

.dark .customer-profile {
	max-height: 128px;
	margin-bottom: 0.3rem;
	box-shadow: 0 0 2px lightgrey;
}

.dark .form-control,
.dark .form-control:focus,
.dark .modal-content {
	background-color: #1a1b1d;
	color: #f7f7f7;
	border-color: #444444;
}

.dark .modal-header {
	background-color: #1a1b1d;
	border: none;
}

.dark .btn-primary {
	background-color: #014b84 !important ;
}

.dark .react-select .react-select__control {
	border: 1px solid #1a1b1d;
}

.dark .card-stats-active .card-footer .btn.btn-sm.btn-link {
	background-color: inherit;
	color: inherit;
}

.dark .bg-white {
	background: #2a2d34 !important;
	box-shadow: none !important;
}

.dark .card-stats-active hr {
	color: #f7f7f7 !important;
	border: 1px solid #444444;
}

.dark .card-stats-active .card-body,
.dark .card-stats-active .card-footer {
	color: white;
	background-color: #000000;
}

.dark .card {
	box-shadow: inherit;
	background-color: #2c2f36 !important;
}

.dark .swal2-popup {
	background: #2a2d34 !important;
}
.dark .card-plain {
	background: none !important;
}

.dark .sidebar[data-color="sidebar"]:after,
.off-canvas-sidebar[data-color="sidebar"]:after {
	background: #1a1b1d;
}
.dark .sidebar .nav .collapse .nav {
	background: #2a2d34 !important;
}

.dark .action-box {
	background-color: #3b3c3e;
}

.dark .btn-success {
	color: #f7f7f7;
	background-color: #145c32; /* Darker green for dark mode */
}

.dark .btn-success:hover {
	color: #f7f7f7;
	background-color: #104628;
	border-color: #0e3b23;
}

.dark .btn-check:focus + .btn-success,
.dark .btn-success:focus {
	color: #f7f7f7;
	background-color: #104628;
	border-color: #0e3b23;
	box-shadow: 0 0 0 0.25rem rgba(20, 92, 50, 0.5); /* Adjusted to match the dark mode */
}

.dark .inventory-select div {
	background-color: rgba(0, 0, 0, 1);
}

.dark * {
	color: lightgrey !important;
}

.dark .form-control:disabled {
	background-color: rgba(120, 120, 120, 0.25);
}

.dark .dropdown-menu {
	color: rgb(245, 244, 244);
}

.dark .card-stats-active {
	background-color: #171717 !important;
	box-shadow: none !important;
	border-radius: 12px;
	color: rgb(200, 200, 200);
	border: 1px solid #444444;
}

.dark .btn-surface:hover,
.dark .nav-pill-bar .nav-item a:hover {
	background-color: #262729;
	color: white;
	text-decoration: none;
}

.dark .btn-surface.active {
	background-color: #171717;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/dark.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;;;;;;;;;;CAWC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,gDAAgD;CAChD,kDAAkD;CAClD,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;;CAGC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;CAEC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;AACrC;;AAEA;CACC,8BAA8B;AAC/B;AACA;CACC,2BAA2B;AAC5B;;AAEA;;CAEC,mBAAmB;AACpB;AACA;CACC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,yBAAyB,EAAE,+BAA+B;AAC3D;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;CACrB,+CAA+C,EAAE,oCAAoC;AACtF;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;CACpC,2BAA2B;CAC3B,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":["/* dark mode style */\n.dark .ReactTable {\n\tcolor: #f7f7f7 !important;\n}\n\n.dark * {\n\tbox-shadow: none;\n}\n\n.dark .main-panel {\n\tbackground: #090a0b !important;\n}\n\n.dark h2,\n.dark h1,\n.dark h3,\n.dark h4,\n.dark h5,\n.dark p,\n.dark .card h1,\n.dark .card-stats-active .btn,\n.dark .card label,\n.dark * label,\n.dark .css-1uccc91-singleValue {\n\tcolor: white !important;\n}\n\n.dark .css-1rhbuit-multiValue {\n\tbackground-color: gray;\n}\n\n.dark .ReactTable .-pagination .-btn {\n\tbackground-color: #014b84;\n}\n\n.dark .rt-tr -odd:hover,\n.dark tr:hover {\n\tbackground-color: #090a0b !important;\n}\n\n.dark thead > tr:hover {\n\tbackground-color: inherit !important;\n}\n\n.dark .ReactTable .rt-table .rt-td {\n\tborder-top: 1px solid rgba(143, 143, 143, 0.267);\n\tborder-right: 1px solid rgba(143, 143, 143, 0.267);\n\ttext-align: center;\n}\n\n.dark .ReactTable .rt-table {\n\tborder: none;\n}\n\n.dark .table thead th {\n\tbackground-color: #2c2f36;\n}\n\n.dark .btn-surface.active {\n\tbackground-color: #383838;\n\tcolor: #f7f7f7;\n}\n\n.dark .table-bordered td,\n.table-bordered th {\n\tborder: 1px solid #000;\n}\n\n.dark hr {\n\tbackground-color: darkgray;\n}\n\n.dark .dropdown-menu {\n\tbackground: #1a1b1d;\n}\n\n.dark.btn-surface:focus {\n\tcolor: inherit;\n}\n\n.dark .btn-link:hover {\n\tbackground-color: #014b84 !important;\n}\n\n.dark .customer-profile {\n\tmax-height: 128px;\n\tmargin-bottom: 0.3rem;\n\tbox-shadow: 0 0 2px lightgrey;\n}\n\n.dark .form-control,\n.dark .form-control:focus,\n.dark .modal-content {\n\tbackground-color: #1a1b1d;\n\tcolor: #f7f7f7;\n\tborder-color: #444444;\n}\n\n.dark .modal-header {\n\tbackground-color: #1a1b1d;\n\tborder: none;\n}\n\n.dark .btn-primary {\n\tbackground-color: #014b84 !important ;\n}\n\n.dark .react-select .react-select__control {\n\tborder: 1px solid #1a1b1d;\n}\n\n.dark .card-stats-active .card-footer .btn.btn-sm.btn-link {\n\tbackground-color: inherit;\n\tcolor: inherit;\n}\n\n.dark .bg-white {\n\tbackground: #2a2d34 !important;\n\tbox-shadow: none !important;\n}\n\n.dark .card-stats-active hr {\n\tcolor: #f7f7f7 !important;\n\tborder: 1px solid #444444;\n}\n\n.dark .card-stats-active .card-body,\n.dark .card-stats-active .card-footer {\n\tcolor: white;\n\tbackground-color: #000000;\n}\n\n.dark .card {\n\tbox-shadow: inherit;\n\tbackground-color: #2c2f36 !important;\n}\n\n.dark .swal2-popup {\n\tbackground: #2a2d34 !important;\n}\n.dark .card-plain {\n\tbackground: none !important;\n}\n\n.dark .sidebar[data-color=\"sidebar\"]:after,\n.off-canvas-sidebar[data-color=\"sidebar\"]:after {\n\tbackground: #1a1b1d;\n}\n.dark .sidebar .nav .collapse .nav {\n\tbackground: #2a2d34 !important;\n}\n\n.dark .action-box {\n\tbackground-color: #3b3c3e;\n}\n\n.dark .btn-success {\n\tcolor: #f7f7f7;\n\tbackground-color: #145c32; /* Darker green for dark mode */\n}\n\n.dark .btn-success:hover {\n\tcolor: #f7f7f7;\n\tbackground-color: #104628;\n\tborder-color: #0e3b23;\n}\n\n.dark .btn-check:focus + .btn-success,\n.dark .btn-success:focus {\n\tcolor: #f7f7f7;\n\tbackground-color: #104628;\n\tborder-color: #0e3b23;\n\tbox-shadow: 0 0 0 0.25rem rgba(20, 92, 50, 0.5); /* Adjusted to match the dark mode */\n}\n\n.dark .inventory-select div {\n\tbackground-color: rgba(0, 0, 0, 1);\n}\n\n.dark * {\n\tcolor: lightgrey !important;\n}\n\n.dark .form-control:disabled {\n\tbackground-color: rgba(120, 120, 120, 0.25);\n}\n\n.dark .dropdown-menu {\n\tcolor: rgb(245, 244, 244);\n}\n\n.dark .card-stats-active {\n\tbackground-color: #171717 !important;\n\tbox-shadow: none !important;\n\tborder-radius: 12px;\n\tcolor: rgb(200, 200, 200);\n\tborder: 1px solid #444444;\n}\n\n.dark .btn-surface:hover,\n.dark .nav-pill-bar .nav-item a:hover {\n\tbackground-color: #262729;\n\tcolor: white;\n\ttext-decoration: none;\n}\n\n.dark .btn-surface.active {\n\tbackground-color: #171717;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
